export class S1WhatifScheduleID{
    scheduleID : number;
}